export default class AjaxPaginationHandler {

    constructor() {
        this.AJAX_LOADING_CLASS = 'loading-next-results';
        document.addEventListener('DOMContentLoaded', () => {
            this.setup();
        });
    }

    setup() {
        this.container = ''
        this.nextPageTrigger = document.querySelector(
            '.paginationWrapper'
        );

        this.container = document.querySelector(
            '.results-container'
        );

        if (this.nextPageTrigger && this.container) {
            this.bindEvents();
        }
    }

    bindEvents() {

        if (this.nextPageTrigger) {
            this.nextPageTrigger.addEventListener(
                'click', (event) => {
                event.preventDefault();

                const button = this.nextPageTrigger.querySelector(
                    '.next.page-numbers'
                );

                if (!button.classList.contains(this.AJAX_LOADING_CLASS)) {
                    button.classList.add(
                        this.AJAX_LOADING_CLASS
                    );
                    fetch(button.href, {
                        method: 'GET',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    })
                        .then(response => {

                            if (response.status === 200) {
                                return response.text();
                            }

                            if (response.status === 404) {
                                this.removePagination(button);
                            }

                            throw new Error(`Unexpected status code: ${response.status}`);
                        })
                        .then(data => {
                            button.classList.remove(
                                this.AJAX_LOADING_CLASS
                            );
                            const responseBody = data.trim();
                            this.appendResults(responseBody);
                            this.incrementPagination(button);
                        })
                        .catch(error => {
                            button.classList.remove(
                                this.AJAX_LOADING_CLASS
                            );
                            console.error(error);
                        });
                }

            });
        }
    }

    appendResults(html) {
        this.container.insertAdjacentHTML(
            'beforeend', html
        );
    }

    incrementPagination(button) {
        const url = new URL(button.href);
        const pageMatch = url.pathname.match(
            /\/sida\/(\d+)/
        );

        if (pageMatch) {
            let currentPage = parseInt(pageMatch[1]);
            let nextPage = currentPage + 1;

            url.pathname = url.pathname.replace(
                /\/sida\/\d+/, `/sida/${nextPage}`
            );
            button.href = url.toString();
        }
    }

    removePagination(button) {
       button.remove();
    }
}
